var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    opacity: 0.3,
    viewBox: "0 0 645.91357421875 521.9100952148438",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    width: "645.91357421875px",
    height: "521.9100952148438px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 645.91357421875,
    height: 521.9100952148438,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1469999998807907, 0, 0, 0.1469999998807907, -169.15748405456543, -226.93069458007812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,6666.6667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50000,0 H 0 V 50000 H 50000 V 0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12",
    transform: "matrix(0.6555832028388977, 0.0033377865329384804, -0.002078064507752129, 0.4081579730320902, 8865.7197265625, 7784.49609375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22017.4,31006.2 v -0.2 l -0.3,0.1 z",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21559,31087.8 c 46.2,177.7 100.1,356.9 160.1,537.3 83.8,-214.4 182.6,-421.9 298,-619 -156.2,34.1 -308.4,60.3 -458.1,81.7",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27758,30828.7 -2,-4.7 c -101.6,-590.9 -241.7,-1109.8 -417.6,-1561.5 l -323.8,220.1 -0.1,0.1 c 257.2,378.3 513.4,838.6 743.5,1346",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32309.3,25322.4 -35.3,-970.3 c -1336.7,-329.2 -2270.2,-638 -2920.6,-944.7 l -1.6,-0.5 v -0.2 c -652.6,-307.9 -1019.8,-613.7 -1223.1,-935.6 -154.6,-24.8 -311.6,-59.4 -471.7,-110.7 -257.5,179.9 -539.2,303.6 -834.3,395.8 l -48.7,19.1 928.3,1554.2 452.6,1584.2 c 1279.4,-475.1 2703,-569.8 4154.4,-591.3",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27502,29151.3 c 237.1,651.3 367.8,1376.3 450.9,2134.3 l -3,-7 c 128.4,320.5 244.7,654.4 343.3,994.1 h 0.2 c 1051.8,915.2 1568.2,1774.1 1708.7,2532 796.6,-864.8 1515.9,-1962.2 2154.8,-3076.3 -1109.9,322.8 -1756.9,-495.3 -1592.3,-1279.3 -1039.9,-363.1 -1005.7,-1345.3 -415.2,-1956.7 -584,44 -1189,74.3 -1813.4,92 l -834,566.9",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16551.6,15467.2 c -4453.3,2095.2 -7537.38,6622.1 -7537.38,11868.6 0,6524.7 7599.88,1788.2 12444.78,5197.8 24.8,-129.3 54.3,-257.5 88.3,-384.3 -119.5,-359.5 -212.9,-701.1 -281.3,-1025.7 -6431.2,620.6 -7017.5,-10109.3 -6076.4,-14913.8 437.4,-273.3 892.1,-521.4 1362,-742.6",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25721.5,20431.4 c 660.9,-209.2 1449.4,-40.2 2197.3,-0.5 -13.3,-716.4 -177.2,-1563.1 -1006.8,-2618 -64.4,1186.3 -379.1,2194.2 -1190.5,2618.5",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28023.1,15361.2 0.5,0.4 -0.1,-0.3 z",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36033.7,25235.5 c 6.6,-58.6 15.4,-114.1 25.9,-166.8 l -369.6,191.8 c 114.1,-7.5 227.8,-15.9 341,-25.7 l 2.7,0.7",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36153.3,27747.4 c 2265.9,-774.2 4832.5,-1237.1 4832.5,-4704.1 0,-1451.3 -356.6,-2914.9 -995.2,-4278.9 144.5,1051.9 131.7,2278.7 -44.1,3686.6 -25.3,723 -509.2,1234.1 -1035.4,1299.9 497.5,1231.3 -15.5,1901.7 -757.5,2116.1 l 4.9,1.5 c -618,598.6 -1409.9,1083.8 -2354,1470 137.4,119.9 255.8,259.3 348.8,408.9",
    style: {
      fill: "#387ac7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22017.1,31006.1 c -1599.8,2732.9 -93.3,7414 2313,5974.9 2348,2507.2 8789.7,-508.8 3963.3,-4708.3 l -6276.3,-1266.6",
    style: {
      fill: "#264675",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36458.9,14181.4 -0.1,0.3 v 0 z",
    style: {
      fill: "#91d3cf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28023.5,15361.3 -4334.7,-1151.9 86,-20.2 72.4,-154.5 c 1762.6,-1215.9 3898.9,-1928.4 6201.6,-1928.4 2394.2,0 4608.4,770.4 6409.7,2075.8 l -677.3,1154.8 -7757.7,24.4",
    style: {
      fill: "#91d3cf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22017.1,31006.1 C 14880,32563.5 14213,21195.4 15189.6,16209.8 c 2011.8,-1256.8 4388.3,-1984 6934.6,-1984 123.4,0 246.4,1.7 368.9,5.2 41.4,1.1 82.7,2.5 124,4 h 0.2 c 40.2,1.5 80.3,3.2 120.4,5 l 4.4,0.3 2.8,0.1 3.5,0.2 c 27.2,1.2 54.4,2.6 81.6,4.1 l 5.4,0.2 28.9,1.6 2.2,0.1 5.9,0.4 9.7,0.5 32.8,1.9 13.8,0.9 7.4,0.5 21.2,1.3 2.4,0.1 29.1,1.9 1.9,0.1 8.9,0.6 21.2,1.4 h 0.9 c 56.7,3.9 113.5,8.2 170,12.7 l 15.5,1.3 3.7,0.3 11.7,0.9 9.4,0.8 6.1,0.5 15,1.3 h 0.4 l 15.4,1.4 26.3,2.3 4.5,0.4 h 0.2 l 25.1,2.3 12.2,1.1 8.7,0.8 12.3,1.1 3.1,0.3 15.3,1.5 2.6,0.2 12.8,1.2 26.9,2.6 2.3,0.2 1.5,0.2 15.4,1.5 4.1,0.4 3,0.4 18,1.8 5.6,0.5 15.4,1.6 2.7,-2.1 1.4,-0.9 1.3,-1.1 0.2,-0.1 2.5,-1.9 1.4,-1 1.3,-1.1 5.5,-4 0.4,-0.3 0.9,-0.7 1.4,-1 2.4,-1.8 0.3,-0.3 0.6,-0.4 3.5,-2.6 1.3,-1.1 0.8,-0.5 0.6,-0.5 1.4,-1 1.3,-1 1.4,-1 0.9,-0.7 0.4,-0.3 1.4,-1.1 1.4,-1 1.3,-1 1.1,-0.8 0.3,-0.2 1.4,-1 1.3,-1 1.4,-1 0.1,-0.1 2.6,-1.9 1.4,-1 1.3,-1 1.4,-1.1 1.3,-1 1.4,-1 1.4,-1 1.4,-1 0.1,-0.1 1.2,-0.9 1.4,-1.1 1.4,-0.9 1.3,-1.1 0.3,-0.2 1.1,-0.8 1.3,-1 1.4,-1 6.8,-5 0.6,-0.5 0.8,-0.6 1.4,-1 1.3,-1 0.5,-0.3 2.3,-1.7 1.3,-1 1.4,-1 1.3,-1 c 19,-14 38,-27.9 57.1,-41.8 l 0.1,0.1 c 73.6,-53.5 147.9,-106 222.8,-157.7 976.1,254.2 1957.9,662.7 2927.1,1241.9 289.1,2218 313.6,4744.8 -1331,5270.9 l 2259,3782.1 452.6,1584.2 c 2376.5,-882.6 5250.8,-452.6 7876.1,-678.9 l 2127.5,633.7 c -1875.1,1816.3 -5352.1,2589.6 -9822.5,2715.9 l -1321.4,898.2 -4997.5,1523.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21455.7,25389.2 3504.8,857 2198.6,-1264.5 -144.5,3840.6 -4997.5,1523.5 -561.4,-4956.6",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23154.2,28895.2 c 359,-790.2 981.9,-1286.4 1868.7,-1488.5 l 23.1,1039 -1891.8,449.5",
    style: {
      fill: "#e86152",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23900,34921.4 c -1297,1534.1 -2537.5,-125 -1244.7,-1720 -1509.1,-2922.5 -332.2,-5119.7 3394.8,-4707.6 1076.9,505.5 2959.2,4202.1 2512.3,6744.5 l -3915.5,814.8 -746.9,-1131.7",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25249.5,26080 1457,-2339 -1062.7,-766.9 -954.1,671.6 559.8,2434.3",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24671.9,26175.6 -522.8,-2335.6 613.9,-49.4 486.5,2289.4 -280.5,228.2 -297.1,-132.6",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23288.5,26048.3 c -208.6,-1744.1 1146.8,-2724.8 3053.2,-3320.8 l 481.3,28.6 c -2165.9,841.4 -3531.3,1865.1 -3314.3,3249.4 l -220.2,42.8",
    style: {
      fill: "#4498d9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17201.8,26301.2 c 625.3,-3926.6 3089.5,-6112.4 8241.5,-5753.8 131.8,888 492.9,1576.5 986.8,2313.7 -677.3,-381 -1232.1,-946.9 -1321.4,-1878.4 -4013,-224.3 -6309,2041 -7906.9,5318.5",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35216.3,25506.4 3575.9,-1855.9 -2240.6,-8555.1 c -3096.7,-242.7 -6128.7,-401 -8528.1,265.9 l 1328.3,8045.6 2922.2,945.2 2942.3,1154.3",
    style: {
      fill: "#91d3cf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32274,24352.1 C 24023.6,22320.6 31122.8,21062 25416.4,16317.6 l 1561.7,-1584.3 c 1841.7,869.8 2966.6,2362.2 2514.4,5224.1 -259.2,2234.4 807.6,3608.8 2781.5,4394.7",
    style: {
      fill: "#7ac1bf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31100.1,22646.7 c 389.9,0 706.1,-316.2 706.1,-706 0,-389.9 -316.2,-706.1 -706.1,-706.1 -389.9,0 -706,316.2 -706,706.1 0,389.8 316.1,706 706,706",
    style: {
      fill: "#264675",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26430.1,22861.1 c 437.6,-100.1 857.1,-242.4 1226.9,-500.7 860,275.3 1629.6,70 2444.3,452.7 241.2,-56.9 384.5,-215.3 430.1,-475.3 l 1131.5,-1063.7 -882.6,-158.4 c 544.9,-977.5 -1032.2,-1759.9 -1652.2,-837.4 -1109.5,468.5 -2620.5,-295.6 -3684.8,269.1 92.6,952 381.5,1753.9 986.8,2313.7",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22589.1,34530.4 c -2274.4,-4311.3 -1726.1,-6689.4 405.7,-7983 l 294.2,407.5 c -3250.1,1826.6 -1619.6,4687.9 -415,7413 l -284.9,162.5",
    style: {
      fill: "#4498d9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24070.7,26761.5 c 1892.8,110 3209.9,1298.4 3685.3,4062.5 l 196.9,461.6 c -257.5,-2348.9 -972.2,-4381 -3889.8,-4886 l 7.6,361.9",
    style: {
      fill: "#4498d9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23508.7,27179 c 324,0 586.8,-262.8 586.8,-586.8 0,-324 -262.8,-586.7 -586.8,-586.7 -323.9,0 -586.7,262.7 -586.7,586.7 0,324 262.8,586.8 586.7,586.8",
    style: {
      fill: "#264675",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34745.5,26931.4 c 1306,-30.8 2327.7,1811 1044.2,2420.6 677.7,594.7 65,1769 -791.7,1572.1 -194.6,1508.5 -2093.7,1522.6 -2669.1,746.4 -1214.3,463.7 -1937.2,-397.7 -1764.3,-1221.4 -1321.6,-461.4 -908.7,-1923 176.6,-2352.3 l 4004.3,-1165.4",
    style: {
      fill: "#264675",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30848.2,29421.8 c -284.5,-2449.8 -115.8,-4212.5 1471.1,-3824.9 l -45.3,-1244.8 c 743.3,-2476.6 2447.8,396.3 2942.3,1154.3 -406.8,688 -557.3,1421.2 -451.3,2199.7 1257.6,1343.7 11.1,2560.1 -680.4,1172.5 -555.2,121.8 -786.9,520.1 -927.9,995.8 -360.5,-363.4 -778.7,-413.4 -1244.8,-203.7 -334,-301.6 -684.4,-429.9 -1063.7,-248.9",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25416.4,16317.6 -1173.9,-933.1 c -607,-109.1 -1213.9,-271.2 -1820.9,-622 l -373.2,-531.5 h 443.8 c 41.7,1.1 83.4,2.5 125,4 h 0.2 c 40.4,1.5 80.8,3.2 121.2,5.1 l 3.5,0.2 2.9,0.1 2.3,0.1 26,1.3 14.2,0.7 h 1.3 l 15.6,0.8 25.6,1.4 5.5,0.2 28.8,1.6 2.3,0.1 5.9,0.4 9.6,0.5 32.9,1.9 13.7,0.9 7.5,0.5 21.1,1.3 2.4,0.1 29.9,1.9 1.1,0.1 9,0.6 21.2,1.4 h 0.8 c 51.7,3.6 103.2,7.4 154.7,11.5 l 13.5,1 1.9,0.2 15.5,1.3 3.7,0.3 11.7,0.9 9.4,0.8 6,0.5 15,1.3 h 0.5 l 15.4,1.4 26.2,2.3 4.6,0.4 24.2,2.2 13.3,1.2 8.6,0.8 12.4,1.1 3,0.3 15.4,1.5 2.6,0.2 12.8,1.2 27.2,2.7 2,0.1 1.5,0.2 15.4,1.5 4.1,0.4 2.2,0.3 18.7,1.9 5.7,0.5 15.3,1.6 1.4,-1 1.3,-1.1 1.4,-0.9 1.3,-1.1 0.2,-0.1 1.2,-0.9 3.7,-2.7 0.3,-0.4 0.4,-0.2 1,-0.8 1.4,-1 1.4,-1 1.3,-1 0.5,-0.3 0.9,-0.7 3.6,-2.7 1,-0.8 0.8,-0.6 1.4,-1 1.3,-1 1.4,-1.1 0.8,-0.5 0.6,-0.5 1.3,-1 1.4,-1 1.3,-1 0.9,-0.7 0.5,-0.3 1.4,-1.1 1.3,-1 1.4,-1 1.1,-0.8 0.2,-0.2 1.4,-1 1.4,-1 0.3,-0.2 1.8,-1.5 1.9,-1.3 1.4,-1 1.4,-1 6.8,-5.1 0.2,-0.1 1.2,-0.9 1.3,-1.1 1.4,-0.9 2.7,-2.1 1.4,-1 1.3,-1 0.4,-0.2 5.1,-3.8 1.4,-1 0.6,-0.5 0.7,-0.6 1.4,-1 2.2,-1.6 0.5,-0.4 0.8,-0.6 0.6,-0.4 1.4,-1 1.3,-1 5.5,-4 h 1903.8 l 1502.9,502.3 -1561.7,1584.3",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36618.7,14233.9 c -52.6,-18 -105.9,-35.4 -159.7,-52.1 53.8,16.7 107.1,34.1 159.7,52.1 z m 260.2,96.1 c -77.2,-30.8 -155.8,-59.9 -235.6,-87.6 79.9,27.7 158.4,56.8 235.6,87.6 z m 159.9,66.6 c -47.1,-20.5 -94.7,-40.4 -142.9,-59.8 48.2,19.4 95.8,39.3 142.9,59.8 z m 236.9,110.4 c -73.4,-36.5 -148.3,-71.6 -224.5,-105 76.2,33.4 151.1,68.5 224.5,105 z m 233.1,123.8 c -70.3,-39.8 -142,-78 -215,-114.8 73,36.8 144.7,75 215,114.8 z m 140,82.7 c -41.7,-25.6 -84,-50.7 -126.8,-75.1 42.8,24.5 85.1,49.4 126.8,75.1 z m 214.5,139.6 c -65,-45 -131.3,-88.4 -199.1,-130.2 67.8,41.8 134.1,85.2 199.1,130.2 z m 209.4,153.9 c -62.7,-49 -127,-96.3 -192.6,-142.2 65.6,45.9 129.9,93.2 192.6,142.2 z m 125.2,101.6 c -39,-32.8 -78.6,-65 -118.8,-96.5 40.2,31.5 79.8,63.7 118.8,96.5 z m 186,165.7 c -57.4,-54.2 -116.4,-106.8 -176.7,-157.9 60.3,51.1 119.3,103.7 176.7,157.9 z m 182.2,181.9 c -54.5,-57.7 -110.4,-113.8 -167.7,-168.3 57.3,54.5 113.2,110.6 167.7,168.3 z m 109.2,120 c -32.9,-37.6 -66.5,-74.5 -100.6,-110.8 34.1,36.3 67.7,73.2 100.6,110.8 z m 162.6,196.3 c -49.7,-63.6 -100.9,-125.6 -153.5,-185.9 52.6,60.3 103.8,122.3 153.5,185.9 z m 154.6,209.6 c -46.6,-67.2 -94.8,-132.7 -144.5,-196.6 49.7,63.9 97.9,129.5 144.5,196.6 z m 93.4,139.6 c -28.1,-43.7 -56.8,-86.7 -86.1,-129.1 29.3,42.4 58,85.4 86.1,129.1 z m 135.5,223.3 c -41.5,-72.7 -84.5,-143.8 -129,-213.2 44.5,69.4 87.5,140.5 129,213.2 z m 130.2,242.5 c -38.9,-77.3 -79.3,-152.9 -121.2,-226.8 41.9,73.9 82.3,149.5 121.2,226.8 z m 76.3,158 c -24.6,-52.9 -49.7,-105.1 -75.6,-156.4 25.9,51.3 51,103.5 75.6,156.4 z m 108.6,250.4 c -33.5,-82.6 -68.6,-163.5 -105.1,-242.8 36.5,79.3 71.6,160.2 105.1,242.8 z m 101.8,268.9 c -30.2,-85.9 -62,-170.1 -95.2,-252.6 33.2,82.5 65,166.7 95.2,252.6 z m 58.7,174.9 c -17.7,-55.2 -36,-109.8 -54.8,-163.8 18.8,54 37.1,108.6 54.8,163.8 z m 83.2,280.3 c -24.7,-90.1 -50.8,-178.5 -78.4,-265.4 27.6,86.9 53.7,175.3 78.4,265.4 z m 75.2,299.4 c -21.4,-93.3 -44.3,-184.8 -68.6,-274.8 24.3,90 47.2,181.5 68.6,274.8 z m 41.3,191.5 c -11.6,-57 -23.7,-113.4 -36.3,-169.3 12.6,55.9 24.7,112.3 36.3,169.3 z m -2236.1,4353.3 c 463.6,1894.1 2236.8,1288.9 2285.9,-113.2 200.5,-1606.1 189,-2976.6 -26.2,-4120.7 v 0.1 l -0.1,-0.4 c -6,-31.8 -12.2,-63.4 -18.5,-94.9 6.3,31.5 12.5,63.1 18.5,94.9 l 0.1,0.3 C 39128.1,16674.5 37931.5,15249.5 36458.6,14182 l -0.1,0.1 -1,-0.8 c -152.6,-47.5 -309.8,-89.9 -471.8,-126.9 L 35171,15186 c 2142.5,-52.8 1659.7,4918.7 2489.6,7378.2 v 0",
    style: {
      fill: "#7ac1bf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35171,15186 c -827,-799.2 -2121.2,86.5 -2468.9,-1226.5 -110,-90.5 -85.5,-181 0,-271.4 1139.8,-432.1 311.7,707.8 3283.6,366.3 L 35171,15186",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36031,25259.8 c 867,1194.4 3991,935.8 2817.9,-1655 -1324.6,587.3 -2669.9,205.6 -2817.9,1655",
    style: {
      fill: "#ef897a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23117.9,34795.2 c 157.3,-89.8 175.6,-353.9 41,-589.9 -134.7,-235.9 -371.4,-354.5 -528.7,-264.7 -157.3,89.8 -175.7,353.9 -41,589.8 134.6,236 371.4,354.5 528.7,264.8",
    style: {
      fill: "#264675",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23718.9,20526 c 817.8,-1713.8 882.1,-3427.6 523.6,-5141.5 l 468.3,372.3 c 405.9,1379.7 292.2,2950.8 -448.6,4752.9 l -543.3,16.3",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25167.3,20530.4 -393,-1634.5 -647.8,1615.7 z",
    style: {
      fill: "#e0e0dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.d2a0a433e6f4ef673f6b5303bf9b783a.svg";
export { ForwardRef as ReactComponent };